import {AuthGuard} from "../guards/auth-guard";
import {Routes} from "@angular/router";
import {CustomerGuard} from "../guards/customer-guard";
import {AnonymousGuard} from "../guards/anonymous-guard";
import {BartenderGuard} from "../guards/bartender-guard";

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../components/home/home.component')
        .then(m => m.HomeComponent),
    canActivate: [CustomerGuard]
  },
  {
    path: 'connexion',
    loadComponent: () =>
      import('../components/login/login.component')
        .then(m => m.LoginComponent),
    canActivate: [AnonymousGuard]
  },
  {
    path: 'connexion/barman',
    loadComponent: () =>
      import('../components/login/login.component')
        .then(m => m.LoginComponent),
    canActivate: [AnonymousGuard]
  },
  {
    path: 'mot-de-passe-oublie',
    loadComponent: () =>
      import('../components/forgotten-password/forgotten-password.component')
        .then(m => m.ForgottenPasswordComponent),
    canActivate: [AnonymousGuard]
  },
  {
    path: 'reinitialiser-mot-de-passe',
    loadComponent: () =>
      import('../components/reset-password/reset-password.component')
        .then(m => m.ResetPasswordComponent),
    canActivate: [AnonymousGuard]
  },
  {
    path: 'commandes',
    loadComponent: () =>
      import('../components/orders/orders.component')
        .then(m => m.OrdersComponent),
    loadChildren: () =>
      import('./orders.routes')
        .then(m => m.ordersRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'commandes/:id',
    loadComponent: () =>
      import('../components/orders/orders.component')
        .then(m => m.OrdersComponent),
    canActivate: [AuthGuard]
  },
  { path: 'compte',
    loadComponent: () =>
      import('../components/account/account.component')
        .then(m => m.AccountComponent),
    loadChildren: () =>
      import('./account.routes')
        .then(m => m.accountRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('../components/contact/contact.component')
        .then(m => m.ContactComponent)
  },
  {
    path: 'cocktails',
    loadComponent: () =>
      import('../components/cocktails/cocktails.component')
        .then(m => m.CocktailsComponent)
  },
  {
    path: 'barmans/:id',
    loadComponent: () =>
      import('../components/bartender/bartender.component')
        .then(m => m.BartenderComponent)
  },
  {
    path: 'barmans',
    loadComponent: () =>
      import('../components/bartenders/bartenders.component')
        .then(m => m.BartendersComponent)
  },
  {
    path: 'reserver',
    loadComponent: () =>
      import('../components/booking/booking.component')
        .then(m => m.BookingComponent)
  },
  {
    path: 'reserver/:id',
    loadComponent: () =>
      import('../components/booking/booking.component')
        .then(m => m.BookingComponent),
    loadChildren: () =>
      import('./booking.routes')
        .then(m => m.bookingRoutes),
    data: {
      hideTabs: true
    }
  },
  {
    path: 'landing/bartender',
    loadComponent: () =>
      import('../components/landing/landing-bartender/landing-bartender.component')
        .then(m => m.LandingBartenderComponent)
  },
  {
    path: 'succes/paiement',
    loadComponent: () =>
      import('../components/success/success-payment/success-payment.component')
        .then(m => m.SuccessPaymentComponent)
  },
  {
    path: 'succes/modification-email',
    loadComponent: () =>
      import('../components/success/success-email-modification/success-email-modification.component')
        .then(m => m.SuccessEmailModificationComponent)
  },
  {
    path: 'echec/paiement',
    loadComponent: () =>
      import('../components/failure/failure-payment/failure-payment.component')
        .then(m => m.FailurePaymentComponent)
  },
  {
    path: 'echec/modification-email',
    loadComponent: () =>
      import('../components/failure/failure-email-modification/failure-email-modification.component')
        .then(m => m.FailureEmailModificationComponent)
  },
  {
    path: 'concept',
    loadComponent: () =>
      import('../components/concept/concept.component')
        .then(m => m.ConceptComponent)
  },
  {
    path: 'carte-cadeau',
    loadComponent: () =>
      import('../components/gift-card/gift-card.component')
        .then(m => m.GiftCardComponent)
  },
  {
    path: 'devenir-barman',
    loadComponent: () =>
      import('../components/become-bartender/become-bartender.component')
        .then(m => m.BecomeBartenderComponent)
  },
  {
    path: 'abonnement',
    loadComponent: () =>
      import('../components/subscription/subscription.component')
        .then(m => m.SubscriptionComponent),
    canActivate: [BartenderGuard]
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('../components/privacy/privacy.component')
        .then(m => m.PrivacyComponent)
  },
  {
    path: 'app',
    loadComponent: () =>
      import('../components/app-mobile/app-mobile.component')
        .then(m => m.AppMobileComponent)
  },
  {
    path: 'search-iframe',
    loadComponent: () =>
      import('../components/search-iframe/search-iframe.component')
        .then(m => m.SearchIframeComponent)
  },
  {
    path: '**',
    loadComponent: () =>
      import('../components/not-found/not-found.component')
        .then(m => m.NotFoundComponent)
  }
];
